import { Flex, Text } from '@mantine/core';
import { FC } from 'react';
import classNames from 'classnames';
import classes from './ContentCheckbox.module.css';
import { Checkbox } from '../../Checkbox';

type ContentCheckboxProps = {
	checked?: boolean;
	leftIcon?: JSX.Element;
	label?: string;
	subtitle?: string;
	objectLoad?: number;
	onClick?: React.MouseEventHandler;
};

export const ContentCheckbox: FC<ContentCheckboxProps> = ({
	checked,
	leftIcon,
	label,
	subtitle = 'Тип бронирования',
	objectLoad = 0,
	...other
}) => {
	return (
		<Flex
			className={classNames(classes.root, {
				[classes.low]: objectLoad >= 0 && objectLoad < 86,
				[classes.middle]: objectLoad >= 86 && objectLoad < 96,
				[classes.high]: objectLoad >= 96 && objectLoad <= 100,
				[classes.notSelected]: !checked,
				// [classes.disabled]: disabled,
			})}
			align="center"
			p="8px 16px 8px 12px"
			gap={8}
			{...other}
		>
			{leftIcon}
			<Flex direction="column">
				<Text fz={16} fw={600} lh="20px">
					{label}
				</Text>
				<Text c="dimmed" fz={14} fw={500} lh="18px">
					{subtitle}
				</Text>
			</Flex>
			<Checkbox checked={checked ?? false} />
		</Flex>
	);
};
